import React, { Component } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { imgStoragePath } from '../../../../constants';
export default class ExportUtilSummery extends Component{
  constructor(props) {
      super(props);
      this.state = {
        exportMenuAnchor: null
      };
    }
  render(){
    const { contract, util_type,aircraft, ctrShortInfo } = this.props;
    return(
      <ul className="list-inline tab-right flex-centered" style={{display: 'inline',padding:'0px 8px'}}>
          <li className="list-inline-item -block">
              <Button
                  size='small'
                  variant='outlined'
                  color='primary'
                  onClick={(e) => this.setState({ exportMenuAnchor: e.currentTarget })}
                  endIcon={<ArrowDropDownIcon style={{ fontSize: '1.15rem' }} />}
              >
                  <SaveAltIcon style={{ fontSize: '1.15rem' }} />Export
              </Button>
              <Menu
                  anchorEl={this.state.exportMenuAnchor}
                  open={Boolean(this.state.exportMenuAnchor)}
                  onClose={() => this.setState({ exportMenuAnchor: null })}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transitionDuration={0}
              >
                  <MenuItem onClick={() => { this.props.exportUtils(contract, 'pdf', util_type, aircraft, ctrShortInfo); this.setState({ exportMenuAnchor: null }); }}>
                      <img src={imgStoragePath+"pdf_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />PDF
                  </MenuItem>
                  <MenuItem onClick={() => { this.props.exportUtils(contract, 'xls', util_type, aircraft, ctrShortInfo); this.setState({ exportMenuAnchor: null }); }}>
                      <img src={imgStoragePath+"excel_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />Excel
                  </MenuItem>
                  <MenuItem onClick={() => { this.props.exportUtils(contract, 'docx', util_type, aircraft, ctrShortInfo); this.setState({ exportMenuAnchor: null }); }}>
                      <img src={imgStoragePath+"docs_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />Doc
                  </MenuItem>
                  <MenuItem onClick={() => { this.props.exportUtils(contract, 'csv', util_type, aircraft, ctrShortInfo); this.setState({ exportMenuAnchor: null }); }}>
                      <img src={imgStoragePath+"excel_icon.png"} alt="img" style={{ marginRight: '8px', width: '16px' }} />CSV
                  </MenuItem>
              </Menu>
          </li>
      </ul>
    )
  }
}
